export const rollerPattern = (color) => {
  return `
        <svg xmlns="http://www.w3.org/2000/svg" width="400" height="180" viewBox="0 0 400 180" fill="none">
        <g filter="url(#filter0_i_68_3)">
        <rect width="400" height="18.2741" fill="${color}"/>
        </g>
        <g filter="url(#filter1_i_68_3)">
        <rect y="17.3604" width="400" height="18.2741" fill="${color}"/>
        </g>
        <g filter="url(#filter2_i_68_3)">
        <rect y="34.7208" width="400" height="18.2741" fill="${color}"/>
        </g>
        <g filter="url(#filter3_i_68_3)">
        <rect y="52.0812" width="400" height="18.2741" fill="${color}"/>
        </g>
        <g filter="url(#filter4_i_68_3)">
        <rect y="69.4417" width="400" height="19.1878" fill="${color}"/>
        </g>
        <g filter="url(#filter5_i_68_3)">
        <rect y="87.7157" width="400" height="19.1878" fill="${color}"/>
        </g>
        <g filter="url(#filter6_i_68_3)">
        <rect y="105.99" width="400" height="19.1878" fill="${color}"/>
        </g>
        <g filter="url(#filter7_i_68_3)">
        <rect y="124.264" width="400" height="19.1878" fill="${color}"/>
        </g>
        <g filter="url(#filter8_i_68_3)">
        <rect y="142.538" width="400" height="19.1878" fill="${color}"/>
        </g>
        <g filter="url(#filter9_i_68_3)">
        <rect y="160.812" width="400" height="19.1878" fill="${color}"/>
        </g>
        <rect x="177" y="96.4873" width="33" height="9.13706" fill="#2C2C2C"/>
        <defs>
        <filter id="filter0_i_68_3" x="0" y="-2" width="400" height="20.2742" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter1_i_68_3" x="0" y="15.3604" width="400" height="20.2742" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter2_i_68_3" x="0" y="32.7208" width="400" height="20.2742" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter3_i_68_3" x="0" y="50.0812" width="400" height="20.2742" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter4_i_68_3" x="0" y="67.4417" width="400" height="21.1879" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter5_i_68_3" x="0" y="85.7157" width="400" height="21.1879" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter6_i_68_3" x="0" y="103.99" width="400" height="21.1879" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter7_i_68_3" x="0" y="122.264" width="400" height="21.1879" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter8_i_68_3" x="0" y="140.538" width="400" height="21.1879" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        <filter id="filter9_i_68_3" x="0" y="158.812" width="400" height="21.1879" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_68_3"/>
        <feOffset dy="-4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"/>
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_68_3"/>
        </filter>
        </defs>
        </svg>
        `;
};
